import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=6f233884"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports